import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import Hero from '../components/sections/Hero'
import TargetAudience from '../components/sections/TargetAudience'
import Solutions from '../components/sections/Solutions'
import Benefits from '../components/sections/Benefits'
import BusinessModel from '../components/sections/BusinessModel'
import HowItWorks from '../components/sections/HowItWorks'
import WhyItWorks from '../components/sections/WhyItWorks'
import FAQ from '../components/sections/FAQ'
import ContactSection from '../components/sections/ContactSection'

export default function HomePage() {
  return (
    <>
      <Header />
      <Hero />
      <TargetAudience />
      <Solutions />
      <Benefits />
      <BusinessModel />
      <HowItWorks />
      <WhyItWorks />
      <FAQ />
      <ContactSection />
      <Footer />
    </>
  )
}